import { Ptag } from "components/core";
import React from "react";
import { newFormatRupees } from "utlis/utils";

function SumInsuredHeaderDetail({ title, value, children, subtitleMinMax, min, max,defaultSumInsured }) {
  return (
    <div>
      <Ptag
        fontFamily="Montserrat"
        fontSize="16px"
        marginBottom="8px"
        color="rgba(255, 255, 255, 1)"
        fontWeight="400"
        lineHeight="32px"
        style={{ whiteSpace: "nowrap" }}
      >
        {title}
      </Ptag>
      {subtitleMinMax ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "32px",
            marginBottom: 4,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Ptag
              fontSize="18px"
              fontWeight="600"
              color="rgba(255, 255, 255, 1)"
            >
              {newFormatRupees(defaultSumInsured)}
            </Ptag>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Ptag fontSize="18px" color="rgba(255, 255, 255, 1)">
              Min:
            </Ptag>
            <Ptag
              fontSize="18px"
              fontWeight="600"
              color="rgba(255, 255, 255, 1)"
              lineHeight="24px"
            >
              {min}
            </Ptag>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Ptag fontSize="18px" color="rgba(255, 255, 255, 1)">
              Max:
            </Ptag>
            <Ptag
              fontSize="18px"
              fontWeight="600"
              color="rgba(255, 255, 255, 1)"
            >
              {max}
            </Ptag>
          </div>
        </div>
      ) : children ? (
        children
      ) : (
        <Ptag
          fontFamily="Montserrat"
          fontSize="18px"
          fontWeight="600"
          color="rgba(255, 255, 255, 1)"
          lineHeight="24px"
        >
          {value}
        </Ptag>
      )}
    </div>
  );
}

export default SumInsuredHeaderDetail;
